<template>
  <va-card>
    <template slot="header">
      <div class="va-card__header-title" color="info">
        <span v-if="$route.params.id">
          <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / <router-link to="/bolge/listesi">{{ $t('menu.regions') }}</router-link> / {{ item.name_readable }}
        </span>
        <span v-else>
          <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / <router-link to="/bolge/listesi">{{ $t('menu.regions') }}</router-link> / {{ $t('tables.actions.create') }}
        </span>
      </div>
      <div class="va-card__header-actions"/>
    </template>
    <form @submit.prevent="onsubmit">
      <div class="row">
        <div class="flex md4 sm6 xs12">
          <va-input
            v-model="form.name"
            label="İsim"
            placeholder="Bölge ismi girin"
            required
          />
        </div>
        <div class="flex md4 sm6 xs12">
          <va-select
            v-model="item.city"
            textBy="name"
            keyBy="id"
            :options="cities"
            label="İl"
            placeholder="Bölge ili seçin"
            :searchable="true"
          />
        </div>
        <div class="flex md4 sm6 xs12">
          <va-select
            v-model="item.type"
            textBy="value"
            keyBy="key"
            :options="types"
            label="Tip"
            placeholder="Bölge tipi seçin"
          />
        </div>
      </div>
      <div class="row">
        <va-button type="submit">Kaydet</va-button>
      </div>
    </form>
  </va-card>
</template>

<script>
import cityServices from '../../services/api/city'
import regionServices from '../../services/api/region'
import responseMixin from '../../services/api/response'
export default {
  mixins: [responseMixin],
  data () {
    return {
      item: {
        name: '',
        type: {},
        city: {}
      },
      form: {
        language: 'tr',
        name: '',
        type: '',
        city_id: null
      },
      types: [
        { key: 'district', value: 'Semt' },
        { key: 'airport', value: 'Havaalanı' }
      ],
      cities: []
    }
  },
  watch: {
    'item.type': function(val) {
      this.form.type = val ? val.key : null;
    },
    'item.city': function(val) {
      this.form.city_id = val ? val.id : null;
    },
    '$route': function(val) {
      this.item = {name: '', type: {}, city: {}};
      this.form = {language: 'tr', name: '', type: '', city_id: null};
      this.initForm();
      if(val.params.id) {
        this.getRegion(val.params.id);
      }
    }
  },
  methods: {
    async getCities(){
      const result = await cityServices.get('',{
        params: {
          page: 1,
          limit: 200
        }
      });
      if(result.error){
        this.cities = [];
        return ;
      }
      this.cities = result.data.data;
    },
    async getRegion(id){
      const result = await regionServices.get(id, {
          params: {
            'include':'city'
          }
        });
      if(result.error){
        this.item = {};
        return ;
      }
      this.item = result.data.data;
      this.formatType();
      this.initForm();
    },
    formatType(){
      if(this.item.type === 'airport') {
        this.item.type = {
          key: this.form.type,
          value: 'Havaalanı'
        };
        return;
      }
      else if(this.item.type === 'district') {
        this.item.type = {
          key: this.item.type,
          value: 'Semt'
        };
      }
    },
    initForm(){
      this.form.name = this.item.name.tr;
      this.form.type = this.item.type ? this.item.type.key : '';
      this.form.city_id = this.item.city_id;
    },
    async postRegion() {
      const res = await regionServices.post({
        data: this.form
      });
      if(res.error){
        //error handling
        this.responseToast('POST', 'error', res);
        return ;
      }
      this.responseToast('POST', 'success');
      this.redirectTo('/bolge/listesi', 2500);
    },
    async putRegion(id) {
      const res = await regionServices.put(id, {
        data: this.form
      });
      if(res.error){
        //error handling
        this.responseToast('PUT', 'error', res);
        return ;
      }
      this.responseToast('PUT', 'success');
    },
    onsubmit () {
      //validation
      if(this.$route.params.id) {
        this.putRegion(this.$route.params.id);
      }
      else {
        this.postRegion();
      }
    },
  },
  created () {
    this.getCities();
    this.initForm();
    if(this.$route.params.id) {
      this.getRegion(this.$route.params.id);
    }
  },
}
</script>